import { useState } from 'react';
import globalState from '../operations/commands';

const useFileUpload = ({
  initialFiles,
  customValidation,
}: {
  initialFiles?: File[];
  customValidation?: (files: File[]) => Promise<Error | null>;
} = {}) => {
  const [files, setFiles] = useState<File[]>(initialFiles ?? []);

  const onDrop = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = e.target.files ? Array.from(e.target.files) : [];
    if (newFiles.length) {
      if (newFiles.some((file) => file.size > 50 * 1000 ** 2)) {
        // ファイルの最大サイズを超えています。'
        return globalState.setErrors({
          message: 'ファイルの最大サイズを超えています。',
          name: 'NonFatalError',
          context: 'file_validation',
        });
      }
      if (customValidation) {
        const error = await customValidation(newFiles);
        if (error)
          return globalState.setErrors({
            message: error.message,
            name: 'NonFatalError',
            context: 'Validation',
          });
      }
      setFiles([...files, ...newFiles]);
      return;
    }
    return;
  };

  const removeFile = (index: number, inputId?: string) => {
    const _file = [...files];
    _file.splice(index, 1);
    setFiles(_file);
    if (inputId) {
      const inputElement = document.getElementById(inputId);
      if (inputElement) (inputElement as HTMLInputElement).value = '';
    }
  };

  return { files, onDrop, removeFile };
};

export default useFileUpload;
